var exports = {
  "N": "xfd349460--0a0899--card",
};

module.exports = exports;
